<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-2-inside-1_327_2668" fill="white">
            <path d="M3 8C3 7.44772 3.44772 7 4 7H17C17.5523 7 18 7.44772 18 8V21C18 21.5523 17.5523 22 17 22H4C3.44772 22 3 21.5523 3 21V8Z"/>
        </mask>
        <path d="M4 8H17V6H4V8ZM17 8V21H19V8H17ZM17 21H4V23H17V21ZM4 21V8H2V21H4ZM4 21L4 21H2C2 22.1046 2.89543 23 4 23V21ZM17 21L17 21V23C18.1046 23 19 22.1046 19 21H17ZM17 8L17 8H19C19 6.89543 18.1046 6 17 6V8ZM4 6C2.89543 6 2 6.89543 2 8H4L4 8V6Z" fill="currentColor" mask="url(#path-2-inside-1_327_2668)"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 5H7V4H8.94444V3.5V3H7C6.44772 3 6 3.44772 6 4V5ZM12.0556 3.5V3H15.9444V3.5V4H12.0556V3.5ZM19.0556 3.5V3H21C21.5523 3 22 3.44772 22 4V5.94444H21.5H21V4H19.0556V3.5ZM21.5 9.05556H22V12.9444H21.5H21V9.05556H21.5ZM21.5 16.0556H22V18C22 18.5523 21.5523 19 21 19H19.0556V18.5V18H21V16.0556H21.5Z" fill="currentColor"/>
        <path d="M6.50049 13.5L13.7428 11.0859L11.3287 18.3282L10.1217 14.7071L6.50049 13.5Z" stroke="currentColor" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGDND',
};
</script>

<style scoped lang="scss">

</style>
